var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "800",
      "title": `${_vm.openedFactory ? '编辑' : '新增'}工厂`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "工厂名",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入材料名..."
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入地址..."
    },
    model: {
      value: _vm.formItem.address,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "address", $$v);
      },
      expression: "formItem.address"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "本厂复配费（元/吨）",
      "prop": "compound_manufactCost"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入费用..."
    },
    model: {
      value: _vm.formItem.compound_manufactCost,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "compound_manufactCost", $$v);
      },
      expression: "formItem.compound_manufactCost"
    }
  })], 1), _c('h4', [_vm._v("母液在本厂的制造费（元/吨）")]), _c('FormItem', [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("聚羧酸母液")]), _c('InputNumber', {
    attrs: {
      "min": 0,
      "placeholder": "聚羧酸母液..."
    },
    model: {
      value: _vm.formItem.PCE_ML_manufactCost,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "PCE_ML_manufactCost", $$v);
      },
      expression: "formItem.PCE_ML_manufactCost"
    }
  })], 1), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("萘系母液")]), _c('InputNumber', {
    attrs: {
      "min": 0,
      "placeholder": "萘系母液..."
    },
    model: {
      value: _vm.formItem.NAP_ML_manufactCost,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "NAP_ML_manufactCost", $$v);
      },
      expression: "formItem.NAP_ML_manufactCost"
    }
  })], 1), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("减胶剂母液")]), _c('InputNumber', {
    attrs: {
      "min": 0,
      "placeholder": "减胶剂母液..."
    },
    model: {
      value: _vm.formItem.J_ML_manufactCost,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "J_ML_manufactCost", $$v);
      },
      expression: "formItem.J_ML_manufactCost"
    }
  })], 1), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("速凝剂母液")]), _c('InputNumber', {
    attrs: {
      "min": 0,
      "placeholder": "速凝剂母液..."
    },
    model: {
      value: _vm.formItem.FSA_ML_manufactCost,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "FSA_ML_manufactCost", $$v);
      },
      expression: "formItem.FSA_ML_manufactCost"
    }
  })], 1)], 1)], 1), _c('FormItem', {
    attrs: {
      "label": "禁用",
      "prop": "disabled"
    }
  }, [_c('i-switch', {
    attrs: {
      "true-color": "#ff4949"
    },
    on: {
      "on-change": _vm.changeInvalid
    },
    model: {
      value: _vm.isInvalid,
      callback: function ($$v) {
        _vm.isInvalid = $$v;
      },
      expression: "isInvalid"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }